import {toMoneyFromCents, type Money} from "../../../../../lib/Money.ts";
import type {PanelBooking, PanelTotals} from "../types.ts";
import type { CurrencyEnum } from '../../../../../generated/enums.ts';

export function panelTotals(bookings: PanelBooking[], currency: CurrencyEnum): PanelTotals {
    const debit = bookings.reduce((sum, booking) => sum + booking.debit.signed_amount, 0);
    const credit = bookings.reduce((sum, booking) => sum + booking.credit.signed_amount, 0);
    return {
        debit: toMoneyFromCents(debit, currency),
        credit: toMoneyFromCents(credit, currency),
        saldo: toMoneyFromCents(debit - credit, currency),
    };
}

export function selectedSum(bookings: PanelBooking[], selectedKeys: Set<string>, currency: CurrencyEnum): Money {
    const cents = bookings
        .filter((booking) => selectedKeys.has(booking.key))
        .reduce(
            (sum, booking) => sum + Math.abs(booking.debit.signed_amount - booking.credit.signed_amount),
            0,
        );
    return toMoneyFromCents(cents, currency);
}
